"use client";

import { useRouter } from "next/navigation";

import { Button } from "@shared/ui/button";

import { OnboardingFlowContainer } from "~/components/onboarding/container";

export default function NotFound() {
  const router = useRouter();

  return (
    <OnboardingFlowContainer showHeader={false} showFooter={false} showAnimatedCubes>
      <div className="flex h-full w-full max-w-[368px] flex-col items-center justify-center gap-8">
        <div className="flex flex-col items-center gap-4 text-center">
          <h1 className="from-progress-bar-indicator-grad-top to-progress-bar-indicator-grad-bottom bg-gradient-to-b bg-clip-text text-[180px] leading-40 font-bold text-transparent">
            404
          </h1>
          <p>We couldn&apos;t find the page you were looking for because the weather was too foggy.</p>
        </div>
        <Button onClick={() => router.back()}>Go back</Button>
      </div>
    </OnboardingFlowContainer>
  );
}
